import { BlogCategoryEntityResponse } from '@/gql/generated/graphql'
import React from 'react'
import { BreadcrumbJsonLd } from 'next-seo';

type Props = {
  category: BlogCategoryEntityResponse
}

export default function CategoryPageHeader(props: Props) {
  return (
    <>
      <BreadcrumbJsonLd
        itemListElements={[
          {
            position: 1,
            name: 'Home',
            item: 'https://www.witopia.com/',
          },
          {
            position: 2,
            name: 'Blog',
            item: 'https://www.witopia.com/blog',
          },
          {
            position: 3,
            name: `${props.category.data?.attributes?.title}`,
            item: `https://www.witopia.com/blog/category/${props.category.data?.attributes?.slug}`,
          }
        ]}
      />
      <section className='blog-detail-banner bg-product-bg pt-[20px] pb-10 md:pb-14'>
        <div className='container'>
          <nav className='breadcrumb flex pb-10 md:pb-[70px]' aria-label='Breadcrumb'>
            <ol className='inline-flex items-center'>
              <li>
                <a href='/'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="10.494" height="11.805" className='w-[12px] h-[12px]' viewBox="0 0 10.494 11.805">
                    <path id="Path_88484" data-name="Path 88484" d="M79.316,0h0L74.069,3.935V11.8H78v.005h6.559V3.935Zm-.952,10.307V7.214h2v3.08h-2v.013Zm3.188-.013V5.714h-4.48v4.591h-1.5V4.685l3.747-2.81,3.746,2.81v5.609Z" transform="translate(-74.069)" fill="#252525"/>
                  </svg>
                </a>
              </li>
              <li>
                <a href='/blog' className='font-roboto font-normal text-sm text-black hover:text-[#5F6368]'>
                  Blog
                </a>
              </li>
              <li aria-current='page'>
                <span className='class="font-roboto font-normal text-sm text-blog-body'>{props.category.data?.attributes?.title}</span>
              </li>
            </ol>
          </nav>
          <h1 className='font-roboto font-medium text-5xl mb-5'>{props.category.data?.attributes?.title}</h1>
        </div>
      </section>
    </>
  )
}
